export const PublicRoutes = {
  user: 'api/user',
  verifySetPasswordToken: '/api/auth/password/verifySetPasswordToken',
  newUser: '/api/newuser',
  logout: '/api/auth/logout',
  oauth: '/oauth',
  login: '/api/auth/login',
  register: '/api/auth/register',
  registerValidate: '/api/auth/register/validate',
  otpLogin: '/api/auth/otp-login',
  setPassword: '/api/auth/password/setPassword',
  updateStatus: '/api/updatestatus',
  passwordEmail: '/api/auth/password/email',
  passwordReset: '/api/auth/password/reset',
  teamInvitations: '/api/stores/team/invitations',
}
